import { ThemeRichTextNodeArray } from '@nucleus/types/web';
import { richText } from './section-jsx';

interface RichTextComponentProp {
  children?: unknown;
}

const extractTemplate = (children: unknown): string => {
  if (typeof children === 'string') {
    return children;
  }
  if (Array.isArray(children)) {
    return children.join('');
  }
  return '';
};

const parseRichTextTemplate = (template: string): Array<unknown> => {
  const result: Array<unknown> = [];
  const pattern = /\{([^}]+)\}/g;
  let lastIndex = 0;
  let match;

  while ((match = pattern.exec(template)) !== null) {
    result.push({ text: template.slice(lastIndex, match.index) });
    result.push({ type: 'parameter', parameter: match[1], fallback: '', children: [{ text: '' }] });
    lastIndex = pattern.lastIndex;
  }

  result.push({ text: template.slice(lastIndex) });

  return result;
};

const parseChildren = (children: unknown): Array<unknown> => {
  return parseRichTextTemplate(extractTemplate(children));
};

type RichTextComponent = (props: RichTextComponentProp) => ThemeRichTextNodeArray;

const RichTextPropsMap = {
  HeadlineOne: { type: 'heading-one', fontStyle: 'headline1' },
  HeadlineTwo: { type: 'heading-two', fontStyle: 'headline2' },
  HeadlineThree: { type: 'heading-three', fontStyle: 'headline3' },
  HeadlineFour: { type: 'heading-four', fontStyle: 'headline4' },
  HeadlineFive: { type: 'heading-five', fontStyle: 'headline5' },
  HeadlineSix: { type: 'heading-six', fontStyle: 'headline6' },
  BodyOne: { type: 'paragraph', fontStyle: 'paragraph1' },
  BodyTwo: { type: 'paragraph', fontStyle: 'paragraph2' },
  BodyThree: { type: 'paragraph', fontStyle: 'paragraph3' },
  BodyFour: { type: 'paragraph', fontStyle: 'paragraph4' },
  OverlineOne: { type: 'div', fontStyle: 'label1' },
  OverlineTwo: { type: 'div', fontStyle: 'label2' },
  OverlineThree: { type: 'div', fontStyle: 'label3' },
  OverlineFour: { type: 'div', fontStyle: 'label4' },
  OverlineFive: { type: 'div', fontStyle: 'label5' },
  OverlineSix: { type: 'div', fontStyle: 'label6' },
} as const;

export const HeadlineOne: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.HeadlineOne, children: parseChildren(children) }]);
};

export const HeadlineTwo: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.HeadlineTwo, children: parseChildren(children) }]);
};

export const HeadlineThree: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.HeadlineThree, children: parseChildren(children) }]);
};

export const HeadlineFour: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.HeadlineFour, children: parseChildren(children) }]);
};

export const HeadlineFive: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.HeadlineFive, children: parseChildren(children) }]);
};

export const HeadlineSix: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.HeadlineSix, children: parseChildren(children) }]);
};

export const BodyOne: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.BodyOne, children: parseChildren(children) }]);
};

export const BodyTwo: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.BodyTwo, children: parseChildren(children) }]);
};

export const BodyThree: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.BodyThree, children: parseChildren(children) }]);
};

export const BodyFour: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.BodyFour, children: parseChildren(children) }]);
};

export const OverlineOne: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.OverlineOne, children: parseChildren(children) }]);
};

export const OverlineTwo: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.OverlineTwo, children: parseChildren(children) }]);
};

export const OverlineThree: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.OverlineThree, children: parseChildren(children) }]);
};

export const OverlineFour: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.OverlineFour, children: parseChildren(children) }]);
};

export const OverlineFive: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.OverlineFive, children: parseChildren(children) }]);
};

export const OverlineSix: RichTextComponent = ({ children }) => {
  return richText([{ ...RichTextPropsMap.OverlineSix, children: parseChildren(children) }]);
};
